<template>
    <div>
        <h1 class="has-text-left na-contact-h1">Contact Us</h1>

        <p class="has-text-left na-contact-text">We're just a phone call or email away! We love technology but we're kind of into that "being human" thing when it comes to communication. Please drop us a line.</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>

        <p class="has-text-left na-contact-text">P.O. Box 308, 5 Lower Main St.</p>
        <p class="has-text-left na-contact-text">Callicoon, NY 12723</p>

        <p class="has-text-left na-contact-text">
            <a href="mailto:info@newsatomic.com">info@scdemocrat.com</a>
            <!--&nbsp;&nbsp;
            <a :href="facebookLink" target="_blank" rel="noopener noreferrer">
                <span class="icon is-medium na-icon-span na-icon-facebook">
                    <i class="fa fa-facebook-square fa-2x"></i>
                </span>
            </a>
            -->
        </p>
        <p class="has-text-left na-contact-text">845-887-5200</p>

        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p class="has-text-left na-contact-text">Please use the form below to send us an email.</p>
        <p>&nbsp;</p>

        <contact-name
            :form-data.sync="formDataName"
            :errors="inputErrors"
        ></contact-name>

        <contact-email
            :form-data.sync="formDataEmail"
            :errors="inputErrors"
        ></contact-email>

        <contact-phone
            :form-data.sync="formDataPhone"
            :errors="inputErrors"
        ></contact-phone>

        <contact-interest
            :form-data.sync="formDataInterest"
            :errors="inputErrors"
        ></contact-interest>

        <contact-comment
            :form-data.sync="formDataComment"
            :errors="inputErrors"
        ></contact-comment>

        <div class="columns">
            <div class="column">
                <a class="button is-success" :class="{ 'is-loading': isBusy }" @click="doSend">
                    <span class="icon is-small">
                        <i class="fa fa-check"></i>
                    </span>
                    <span>
                        Send
                    </span>
                </a>

                <a v-if="!noHeader" class="button is-danger" @click="doCancel">
                    <span class="icon is-small">
                        <i class="fa fa-times"></i>
                    </span>
                    <span>
                        Cancel
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mediaMixin } from '@/mixins/MediaMixin.js';
    import ContactComment from '../../Shared/Comment.vue';
    import ContactEmail from '../../Shared/Email.vue';
    import ContactInterest from '../../Shared/Interest.vue';
    import ContactName from '../../Shared/Name.vue';
    import ContactPhone from '../../Shared/Phone.vue';

    export default {
        components: {
            ContactComment,
            ContactEmail,
            ContactInterest,
            ContactName,
            ContactPhone
        },
        mixins: [mediaMixin],
        props: {
            noHeader: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isBusy: false,
                errors: [],
                inputErrors: [],
                formDataName: {},
                formDataEmail: {},
                formDataPhone: {},
                formDataInterest: {},
                formDataComment: {}
            };
        },
        computed: {
            ...mapGetters({
                mainPublicationId: 'publication/mainPublicationId',
            }),
            /**
             * Return link to SJ's FB
             */
            facebookLink () {
                return naVariables.urlKwFacebook;
            },
        },
        mounted () {
            this.clientScrollTop();
        },
        methods: {
            /**
             * Clear form fields
             */
            clearForm () {
                this.formDataName = {
                    name: null
                };
                this.formDataEmail = {
                    email: null
                };
                this.formDataPhone = {
                    phone: null
                };
                this.formDataInterest = {
                    interest: []
                };
                this.formDataComment = {
                    comment: null
                };
            },
            /**
             * Send form
             */
            doSend () {
                const data = {
                    publication_id: this.mainPublicationId,
                    name: this.formDataName.name,
                    email: this.formDataEmail.email,
                    phone: this.formDataPhone.phone,
                    interest: this.formDataInterest.interest.join(','),  // Pretty simple form - just combining into one field - NOT a separate table for each interest
                    comment: this.formDataComment.comment
                };
                this.errors = [];
                this.inputErrors = [];
                this.isBusy = true;
                Promise.all([
                    this.doCreateContactUs(data)
                        .then((response) => {
                            this.isBusy = false;
                            if (!response.response.success) {
                                this.errors = response.response.errors ? response.response.errors : null;
                                this.inputErrors = response.response.inputErrors ? response.response.inputErrors : null;
                            } else {
                                this.clearForm();
                                this.$swal({
                                    type: 'success',
                                    title: 'Thank you!',
                                    text: '', //We will review your request and get back to you soon.',
                                    showCancelButton: false
                                });
                                this.$emit('cancel');
                            }
                        })
                ])
                .then(() => {
                }, () => {
                    this.isBusy = false;
                    this.inputErrors.push('name|Internal Error');
                });
            },
            /**
             * Cancel
             */
            doCancel () {
                this.$emit('cancel');
            }
        }
    }
</script>
